import { ENGLISH_UI_TRANSLATIONS } from "../i18n/generatedEnglishUi";
import { ENGLISH_UI_OVERRIDES } from "../i18n/englishUiOverrides";

export const ENGLISH_UI = Object.freeze({
  ...ENGLISH_UI_TRANSLATIONS,
  ...ENGLISH_UI_OVERRIDES,
});

const ENGLISH_FRAGMENTS = Object.entries(ENGLISH_UI)
  .filter(([source]) => source.length >= 8 || (source.length >= 4 && (/^\s|\s$/.test(source))))
  .sort(([left], [right]) => right.length - left.length);

const splitWhitespace = (value) => {
  const match = String(value || "").match(/^(\s*)([\s\S]*?)(\s*)$/);
  return match ? [match[1], match[2], match[3]] : ["", String(value || ""), ""];
};

export const translateUiText = (value, locale = "en") => {
  const text = String(value ?? "");
  if (locale !== "en" || !text.trim()) return text;
  const [leading, core, trailing] = splitWhitespace(text);
  const exact = ENGLISH_UI[core];
  if (exact) return `${leading}${exact}${trailing}`;

  let translated = core;
  for (const [source, target] of ENGLISH_FRAGMENTS) {
    if (translated.includes(source)) translated = translated.split(source).join(target);
  }
  return `${leading}${translated}${trailing}`;
};

export const shouldLocalizePath = (pathname) => {
  const path = String(pathname || "");
  return ![
    "/admin",
    "/engineer",
    "/vst-visual-render",
  ].some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
};
